import { useId } from 'react';

import { Card, H2 } from '@betterment/samba-react';

import { CashAccountRow, CashAccountRowHeader } from './components/CashAccountRow';
import { InvestingAccountRow, InvestingAccountRowHeader } from './components/InvestingAccountRow';
import { UnderstandingReturnsDialog } from './components/understanding-returns/UnderstandingReturnsDialog';

import { DateRangeOption } from '../../../../graphql/schema';
import { accountsByType } from '../../../shared/utils';
import { PerformanceAccountsQuery } from '../../graphql/performanceAccounts.generated';

export const AccountsCard: React.FC<{
  accounts: PerformanceAccountsQuery['performance']['accounts'];
  dateRangeOption: DateRangeOption;
}> = ({ accounts, dateRangeOption }) => {
  const investmentsHeadingId = useId();
  const cashHeadingId = useId();

  if (accounts.length === 0) {
    return null;
  }

  const { cashAccounts, investingAccounts } = accountsByType(accounts);

  return (
    <>
      {investingAccounts.length > 0 && (
        <Card role="region" aria-labelledby={investmentsHeadingId}>
          <Card.Header css={{ padding: 'space.300' }}>
            <H2 id={investmentsHeadingId} variant="title200">
              Investments
            </H2>
          </Card.Header>
          <Card.Content>
            <InvestingAccountRowHeader />
            {investingAccounts.map(a => (
              <InvestingAccountRow key={a.id} accountId={a.id} dateRangeOption={dateRangeOption} />
            ))}
          </Card.Content>
          <Card.Footer css={{ padding: 'space.300' }}>
            <UnderstandingReturnsDialog />
          </Card.Footer>
        </Card>
      )}
      {cashAccounts.length > 0 && (
        <Card role="region" aria-labelledby={cashHeadingId}>
          <Card.Header css={{ padding: 'space.300' }}>
            <H2 id={cashHeadingId} variant="title200">
              Cash
            </H2>
          </Card.Header>
          <Card.Content>
            <CashAccountRowHeader />
            {cashAccounts.map(a => (
              <CashAccountRow key={a.id} accountId={a.id} dateRangeOption={dateRangeOption} />
            ))}
          </Card.Content>
        </Card>
      )}
    </>
  );
};
